<template>
    <div class="cps-checkbox">
        <!-- Native checkbox + label to align with PricingDisplay.vue style -->
        <input
            class="checkbox"
            :id="computedId"
            type="checkbox"
            v-model="tempValue"
            v-bind="$attrs"
            @input="emitValue"
        />
        <label class="text-muted" :for="computedId" style="margin-bottom: 0px">
            <slot></slot>
        </label>
    </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: ''
      },
      value: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        tempValue: !!this.value
      };
    },
    computed: {
      computedId() {
        return this.id && this.id.length > 0 ? this.id : `cps_checkbox_${this._uid}`;
      }
    },
    watch: {
      value(newVal) {
        this.tempValue = !!newVal;
      }
    },
    methods: {
      emitValue(val) {
        // BootstrapVue emits the new checked state via @input
        this.tempValue = !!val;
        this.$emit('input', !!val);
      }
    }
  };
</script>

<style lang="scss" scoped>
.cps-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;

    /* keep alignment consistent with other form controls */
    .custom-control-label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.8);
        line-height: 1.5;
    }
}
</style>

